import { z } from "zod";

/**
 * analyticsEventSchema is the closed vocabulary of custom events Mountaya emits.
 * Autocaptured interactions and pageviews are not listed: PostHog names those
 * itself. Holding the names in one enum is what keeps a dashboard from silently
 * losing a series to a renamed or misspelled event.
 *
 * tool_dispatched is one event per tool-bus dispatch, carrying the tool name,
 * capability, outcome, and latency as properties. One event with a `tool`
 * property beats one event name per tool: the tool set grows, and PostHog groups
 * far better by property than by event name.
 */
export const analyticsEventSchema = z.enum(["tool_dispatched"]);

/**
 * AnalyticsEvent is a custom event name, derived from analyticsEventSchema.
 */
export type AnalyticsEvent = z.infer<typeof analyticsEventSchema>;
